import { TwemojiImg } from '../../lib/twemoji.jsx'
import { VEHICLE_TYPES } from '../../lib/constants.js'

export default function VehiclePicker({ value, onChange }) {
  return (
    <div className="flex-1 min-h-0 overflow-y-auto">
      <div className="grid grid-cols-4 gap-2 p-1">
        {VEHICLE_TYPES.map(v => {
          const selected = value === v.emoji
          return (
            <button
              key={v.id}
              type="button"
              onClick={() => onChange(v.emoji)}
              className={`relative flex flex-col items-center gap-1 p-2 rounded-xl border-2 transition-all duration-150 active:scale-90 ${
                selected
                  ? 'border-white bg-white/25 shadow-lg'
                  : 'border-white/20 bg-white/5 hover:bg-white/15'
              }`}
            >
              <TwemojiImg emoji={v.emoji} size={44} />
              <span className="text-white/80 text-xs leading-tight text-center w-full truncate">
                {v.label}
              </span>
              {selected && (
                <div className="absolute top-1 right-1 w-4 h-4 bg-white text-primary rounded-full text-xs font-semibold flex items-center justify-center shadow">
                  ✓
                </div>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
